import { createFileRoute, notFound } from "@tanstack/react-router";
import AreaPage from "@/pages/AreaPage";
import { buildHead } from "@/lib/seo";
import { areas } from "@/data/areas";

export const Route = createFileRoute("/areas/$cityName")({
  loader: async ({ params }) => {
    const area = areas.find((a) => a.slug === params.cityName);
    if (!area) {
      // Unmatched area slugs (including the literal "$cityName") must return a
      // genuine HTTP 404, not a 200 page that renders the 404 UI (soft 404).
      throw notFound();
    }
    return { area };
  },
  head: ({ loaderData }) => {
    const area = loaderData?.area;
    if (!area) {
      // loaderData is undefined whenever the loader threw notFound(). Serve a
      // noindex head so the soft-404 path is never indexed even transiently.
      return {
        meta: [
          { title: "Area Not Found | Precision Pavers & Pool Design" },
          { name: "robots", content: "noindex" },
          {
            name: "description",
            content:
              "Precision Pavers & Pool Design — your local outdoor living experts.",
          },
        ],
      };
    }
    const path = `/areas/${area.slug}`;
    return buildHead({
      title: `Pool Remodeling, Pavers & Deck Services in ${area.name}, FL | Precision Pavers & Pool Design`,
      description:
        area.seoDescription ||
        `Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in ${area.name}. Family-owned. Tremron and Belgard materials. Free estimates. Serving all of Broward County.`,
      path,
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Areas",
            item: "https://precisionpaverspools.com/areas",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: area.name,
            item: `https://precisionpaverspools.com/areas/${area.slug}`,
          },
        ],
      },
    });
  },
  component: AreaPage,
});
